import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: 'Contestás WhatsApp a cualquier hora sin ningún filtro',
  good: 'Banco de respuestas y guía de derivación que cortan la consulta antes de que llegue a vos'
}, {
  bad: 'El paciente abandona el tratamiento sin entender por qué',
  good: 'Cronograma claro que anticipa cada etapa del proceso'
}, {
  bad: 'Cada complicación post-procedimiento genera un llamado de pánico',
  good: 'Tarjeta de alarma que el paciente ya tiene en la mano'
}, {
  bad: 'Sin consentimiento firmado como corresponde',
  good: 'Modelos editables listos por cada procedimiento'
}, {
  bad: 'Repetís la misma indicación en cada consulta',
  good: 'Cuadernillos entregables que hacen ese trabajo por vos'
}, {
  bad: 'Presentar un presupuesto se siente incómodo',
  good: 'Guion y plantilla que lo convierten en parte de la indicación'
}, {
  bad: 'Tu presencia en redes no refleja tu matrícula',
  good: 'Protocolo de marca profesional para tu contenido'
}];
export function Comparison() {
  return <section className="py-12 md:py-24 bg-brand-light" data-id="element-15">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="text-center mb-8 md:mb-16" data-id="element-17">
          <h2 className="text-xs md:text-sm font-bold text-brand-gold uppercase tracking-widest mb-2 md:mb-3" data-id="element-18">
            La Realidad
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-brand-navy mb-3 md:mb-6" data-id="element-19">
            ¿Cuánto te cuesta NO tenerlo?
          </h3>
        </div>

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden border border-slate-200" data-id="element-20">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-21">
            <div className="bg-slate-50 p-5 md:p-10 border-b md:border-b-0 md:border-r border-slate-200" data-id="element-22">
              <h4 className="text-lg md:text-xl font-bold text-slate-800 mb-5 md:mb-8 flex items-center gap-2 md:gap-3" data-id="element-23">
                <XCircle className="text-red-500 w-5 h-5 md:w-6 md:h-6" data-id="element-24" />
                Sin el Protocolo
              </h4>
              <ul className="space-y-4 md:space-y-6" data-id="element-25">
                {comparisons.map((item, i) => <li key={i} className="flex gap-3 md:gap-4 text-sm md:text-base text-slate-600" data-id="element-26">
                    <span className="text-red-400 mt-0.5 md:mt-1 flex-shrink-0" data-id="element-27">
                      •
                    </span>
                    <span data-id="element-28">{item.bad}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-brand-navy p-5 md:p-10 text-white relative overflow-hidden" data-id="element-29">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-2xl" data-id="element-30"></div>
              <h4 className="text-lg md:text-xl font-bold text-brand-gold mb-5 md:mb-8 flex items-center gap-2 md:gap-3 relative z-10" data-id="element-31">
                <CheckCircle2 className="text-brand-gold w-5 h-5 md:w-6 md:h-6" data-id="element-32" />
                Con el Protocolo
              </h4>
              <ul className="space-y-4 md:space-y-6 relative z-10" data-id="element-33">
                {comparisons.map((item, i) => <li key={i} className="flex gap-3 md:gap-4 text-sm md:text-base text-slate-200" data-id="element-34">
                    <span className="text-brand-gold mt-0.5 md:mt-1 flex-shrink-0" data-id="element-35">
                      ✓
                    </span>
                    <span data-id="element-36">{item.good}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}